<div class="quick-intake-container">
  <ng-switch [ngSwitch]="currentFormState">
    <ng-container *ngSwitchCase="quickIntakeFormState.FORM" [ngTemplateOutlet]="form"></ng-container>
    <ng-container *ngSwitchCase="quickIntakeFormState.PROCESSING" [ngTemplateOutlet]="processing"></ng-container>
    <ng-container *ngSwitchCase="quickIntakeFormState.ERROR" [ngTemplateOutlet]="error"></ng-container>
    <ng-container *ngSwitchCase="quickIntakeFormState.SUBMITTED" [ngTemplateOutlet]="submitted"></ng-container>
  </ng-switch>
</div>

<ng-template #form>
  <form class="quick-intake-form" [formGroup]="quickIntakeForm" *ngIf="quickIntakeForm">
    <div class="question-group">
      <h2>Please share your main reasons for seeking therapy support?</h2>

      <iris-form-field
        class="open-preferences-form-field"
        label="Include any issues you’re hoping to address, and any preferences you’d like in a provider."
      >
        <iris-text-area
          formControlName="openPreferences"
          [autoResizeEnabled]="true"
        >
        </iris-text-area>
      </iris-form-field>
    </div>


    <div class="question-group">
      <h2>Are any of these important to you?</h2>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
          <span>Virtual vs. in-person</span> 
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <iris-radio-group
            *ngIf="sessionPreferenceTypes?.length"
            [canBeNull]="true"
            [options]="sessionPreferenceTypes"
            formControlName="sessionFormatPreference"
          >
          </iris-radio-group>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
          <span>Therapist gender</span> 
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <iris-radio-group
            *ngIf="genderTypes?.length"
            [canBeNull]="true"
            [options]="genderTypes"
            formControlName="genderPreference"
          >
          </iris-radio-group>
        </div>
      </mat-expansion-panel>

      <iris-checkbox
        class="medication-management-checkbox"
        formControlName="medicationManagement" 
      >
        Help managing my medication
      </iris-checkbox>
    </div>

    <div class="question-group">
      <h2>Which best describes you?</h2>

      <iris-radio-group
        class="readiness-radio-group"
        [options]="readinessOptions"
        [canBeNull]="true"
        formControlName="readiness">
      </iris-radio-group>
    </div>

    <div class="question-group">
      <h2>Finally, tell us a little about the person receiving care:</h2>

      <iris-form-field label="First name">
        <iris-text-input formControlName="firstName"> </iris-text-input>
      </iris-form-field>

      <iris-form-field label="Last name">
        <iris-text-input formControlName="lastName"></iris-text-input>
      </iris-form-field>

      <iris-form-field
        label="Birthday"
        [customErrorMessages]="{
          dateFormat: 'Dates must be in correct format of MM/DD/YYYY Month/Day/Year' 
        }"
      >
        <iris-text-input
          formControlName="birthdate"
          autocomplete="bday"
          placeholder="mm/dd/yyyy"
          [mask]="birthdayMask"
          [markMaskAsPristine]="false"
          [dropSpecialCharacters]="false"
        >
        </iris-text-input>
      </iris-form-field>

      <iris-form-field
        label="Location"
        [customErrorMessages]="{
          invalidLocation: 'Please select a valid location'
        }"
      >
        <iris-text-input
          [formControl]="locationFormControl"
          googleMapsAutoComplete
          placeholder="City or ZIP Code"
          (onAutoCompleteSelected)="locationSelected($any($event))"
        >
        </iris-text-input>
      </iris-form-field>
    
      <div class="not-in-your-state" *ngIf="notAvailableInYourState">
        <h3>Let's stay in touch.</h3>
        <p>We're not in your state yet. Sign up for SonderMind updates and be the first to know when we are.</p>
        <a
          class="iris-button iris-button--secondary"
          target="_blank"
          [href]="comingToYourStateLink"
        >
          Sign up
        </a>
      </div>
    
      <iris-form-field 
        label="How you plan to pay for therapy" 
      >
        <iris-dropdown
          formControlName="paymentType"
          [options]="availablePaymentTypes"
          placeholder="Select a payment method"
        ></iris-dropdown>
        <iris-hint *ngIf="quickIntakeForm.controls.paymentType.disabled">
          Select a location to unlock payment options
        </iris-hint>
      </iris-form-field>
    
      <iris-form-field 
        *ngIf="showInsurancePlans"
        [label]="insuranceFormLabel" 
      >
        <iris-dropdown
          formControlName="insurance"
          [options]="acceptedInsurances"
          placeholder="Select a plan"
        ></iris-dropdown>
      </iris-form-field>

      <iris-form-field
        label="Email"
        [customErrorMessages]="{
          emailFormat: 'Please enter a valid email address.'
        }"
      >
        <iris-text-input 
          formControlName="email"
          placeholder="The email you want associated with this account"
        ></iris-text-input>
      </iris-form-field>

      <iris-form-field
        label="Phone"
        [customErrorMessages]="{
          phoneNumberFormat: 'Please enter a valid phone number',
          invalidPhoneNumber: 'Please enter a valid phone number'
        }"
      >
        <iris-text-input 
          formControlName="phone"
          placeholder="(___) ___-____"
          [mask]="phoneMask"
          [markMaskAsPristine]="false"
          data-test="phone-number"
        ></iris-text-input>
      </iris-form-field>

      <iris-checkbox 
        formControlName="contactSmsAllowed" 
      >
        Yes, SMS text message any session reminders and account updates (standard messaging rates apply)
      </iris-checkbox>
    </div>

    <div class="question-group">
      <h2>How should your provider contact you?</h2>
      <iris-form-field>
        <div formGroupName="commPrefs">
          <iris-checkbox formControlName="commPrefsSms">
            SMS text message (standard messaging rates apply)
          </iris-checkbox>
          <iris-checkbox formControlName="commPrefsPhone">
            Phone call (they'll leave a voicemail if you aren't available)
          </iris-checkbox>
        </div>
      </iris-form-field>
    </div>

    <iris-button
      class="submit-button"
      [disabled]="!quickIntakeForm.valid || !locationFormControl.valid || notAvailableInYourState"
      (click)="formSubmitted()"
    >
      Send me my therapist matches
    </iris-button>
  </form>
</ng-template>

<ng-template #processing>
  <matching-progress></matching-progress>
</ng-template>

<ng-template #error>
  <div class="error-container">
    <h3>There was an error when submitting your request</h3>
    <p>Please try again.</p>
    <iris-button (click)="backToForm()">Back to form</iris-button>
  </div>
</ng-template>

<ng-template #submitted>
  <div class="submitted-container">
    <iris-empty-state
      title="We're sending you a login link"
      [details]="'You’ll receive ' + (quickIntakeForm.controls.contactSmsAllowed.value ? 'a text and an email' : 'an email') + ' in the next few minutes from SonderMind Support. Tap on the link to see the therapists we recommend for you'"
      imageSrc="/assets/email-sent-icon.svg"
    />

    <p class="resend-support-message">
      If you don’t receive something from us, hang tight! It could take a few minutes to arrive.
      You can also check your spam folder or contact the support team at
      <a
        class="support-link"
        href="https://www.sondermind.com/contact-us/"
        target="_blank"
      >sondermind.com/contact-us</a>.
    </p>
  </div>
</ng-template>
